import { CommonAPI } from "../Client";

export const getWhatsappEmbeddedSignupConfigApi = () =>
  CommonAPI.get("/company/whatsapp/embedded-signup/config");

export const completeWhatsappEmbeddedSignupApi = (payload) =>
  CommonAPI.post("/company/whatsapp/embedded-signup/complete", payload, {
    headers: { Prefer: "respond-async" },
    skipSuccessNotification: true,
  });

export const getWhatsappEmbeddedSignupStatusApi = (statusUrl) =>
  CommonAPI.get(statusUrl);

const buildBodyWithoutCompanyId = (payload = {}) => {
  const { companyId, ...body } = payload;
  return body;
};

export const getCompanyWhatsappDetailApi = ({ companyId, businessId }) =>
  CommonAPI.get("/company/whatsapp/detail", { params: { companyId, businessId } });

export const getCompanyWhatsappDetailsApi = ({ companyId }) =>
  CommonAPI.get("/company/whatsapp/details", { params: { companyId } });

// CommonAPI already includes the /common base path.
export const getCompanyWhatsappCredentialsApi = ({ whatsAppBusinessId }) =>
  CommonAPI.get("/company/whatsapp/credentials", { params: { whatsAppBusinessId } });

export const postCompanyWhatsappDetailApi = (payload) =>
  CommonAPI.post("/company/whatsapp/detail", buildBodyWithoutCompanyId(payload), {
    params: { companyId: payload.companyId },
  });

export const updateCompanyWhatsappDetailApi = (payload) =>
  CommonAPI.put("/company/whatsapp/detail", buildBodyWithoutCompanyId(payload));

export const getCompanyShiprocketDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/shiprocket/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyShiprocketDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/shiprocket/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyShiprocketDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/shiprocket/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyRazorpayDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/razorpay/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyRazorpayDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/razorpay/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyRazorpayDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/razorpay/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyOauthDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/oauth/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyOauthDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/oauth/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyOauthDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/oauth/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyAnalyticDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/analytic/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyAnalyticDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/analytic/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyAnalyticDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/analytic/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};
